import { ExpressOrderItem, ExpressOrderItemType } from '../types';
import { AdditionalFeeModel } from '../models/AdditionalFee.model';

export const getAdditionalFeesOrderItems = (
  fees: AdditionalFeeModel[],
): ExpressOrderItem[] =>
  fees?.map((fee, index) => ({
    id: fee.code ?? `additional-fee-${index}`,
    name: fee.name ?? /* istanbul ignore next */ '',
    price: fee.price?.amount ?? /* istanbul ignore next */ '0',
    quantity: 1,
    type: ExpressOrderItemType.Fee,
  })) || /* istanbul ignore next */ [];
